const ApertureMining = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="376.000000pt"
    height="376.000000pt"
    viewBox="0 0 376.000000 376.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,376.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M1683 3713 c-27 -4 -58 -32 -185 -169 -84 -90 -154 -169 -156 -174
  -2 -7 287 -10 807 -10 446 0 811 3 811 8 0 14 -166 114 -285 172 -259 126
  -513 182 -808 178 -84 0 -167 -3 -184 -5z"
      />
      <path
        d="M1422 3665 c-146 -38 -206 -61 -367 -141 -193 -95 -309 -178 -472
  -339 l-133 -131 0 -249 0 -250 311 310 c378 377 798 825 772 825 -10 -1 -60
  -12 -111 -25z"
      />
      <path
        d="M3125 2730 c314 -314 571 -566 573 -561 5 16 -49 230 -80 321 -95
  270 -268 536 -474 729 l-87 81 -251 0 -251 0 570 -570z"
      />
      <path
        d="M1810 3230 c-19 -4 -26 -14 -30 -40 -4 -27 -10 -36 -27 -38 -16 -2
  -23 2 -23 12 0 23 -14 20 -45 -11 -35 -36 -53 -71 -61 -122 -4 -24 -12 -41
  -20 -41 -16 0 -29 -39 -17 -51 5 -5 129 -8 289 -7 l279 3 3 23 c3 17 -2 25
  -17 29 -15 4 -21 14 -21 32 0 33 -31 97 -64 136 -25 29 -27 29 -40 12 -22 -29
  -50 -17 -56 22 -4 27 -11 36 -32 42 -26 7 -27 5 -30 -35 -3 -36 -6 -41 -28
  -41 -22 0 -26 5 -30 41 -5 37 -7 40 -30 34z"
      />
      <path
        d="M326 2874 c-117 -181 -213 -418 -255 -630 -28 -140 -43 -339 -35
  -449 l7 -93 173 -173 174 -174 0 803 c0 441 -2 802 -4 802 -2 0 -29 -39 -60
  -86z"
      />
      <path
        d="M1632 2841 c10 -146 161 -248 303 -206 59 17 126 68 150 116 20 37
  36 114 29 133 -5 14 -38 16 -246 16 l-240 0 4 -59z"
      />
      <path
        d="M2482 2758 c112 -111 248 -307 248 -358 0 -22 -12 -32 -97 -75 -54
  -28 -120 -62 -146 -78 -44 -25 -50 -26 -75 -13 -43 22 -136 126 -197 220 -36
  56 -65 90 -82 97 -16 6 -122 9 -267 7 l-241 -3 -60 -29 c-35 -17 -86 -56 -123
  -92 -103 -103 -152 -237 -152 -419 0 -161 49 -393 90 -430 32 -29 88 -25 116
  9 28 32 30 54 8 125 -63 215 -56 433 19 546 57 86 57 85 57 -214 0 -149 2
  -271 4 -271 15 0 563 295 574 309 7 9 12 38 12 66 -1 28 -1 54 -1 59 1 5 22
  -12 47 -38 25 -26 44 -49 42 -49 -51 -25 -63 -38 -66 -70 l-3 -35 64 34 63 33
  43 -21 c93 -46 203 -20 276 64 34 39 36 47 32 91 l-4 48 48 24 c26 14 55 22
  64 19 46 -18 164 -353 165 -469 l1 -40 17 30 c13 23 17 53 16 125 -1 104 -19
  191 -66 308 -17 40 -27 80 -24 89 11 28 -13 81 -42 94 -15 7 -44 37 -64 68
  -95 147 -237 273 -332 295 -25 6 -21 0 36 -56z"
      />
      <path
        d="M3360 1594 c0 -512 3 -803 10 -799 19 12 125 192 175 300 125 263
  180 524 173 817 l-3 148 -170 170 c-93 93 -173 170 -177 170 -5 0 -8 -363 -8
  -806z"
      />
      <path
        d="M1872 1851 c-156 -82 -287 -153 -292 -157 -4 -5 -15 -88 -24 -184 -9
  -96 -30 -317 -46 -490 -40 -419 -40 -413 9 -461 34 -34 44 -39 86 -39 54 0 95
  21 119 61 15 26 33 186 99 924 l12 130 35 3 36 3 38 -413 c64 -698 53 -627 96
  -670 33 -34 43 -38 86 -38 54 0 99 23 120 62 20 36 17 94 -31 606 -29 317 -45
  533 -46 645 0 92 -4 167 -7 167 -4 -1 -135 -68 -290 -149z"
      />
      <path
        d="M1530 1733 c0 -10 5 -25 10 -33 7 -11 10 -7 10 18 0 17 -4 32 -10 32
  -5 0 -10 -8 -10 -17z"
      />
      <path
        d="M1194 1569 c-96 -51 -111 -63 -107 -80 3 -11 11 -23 18 -25 12 -5
  220 100 230 117 7 10 -12 49 -23 48 -4 0 -57 -27 -118 -60z"
      />
      <path
        d="M60 1580 c0 -14 9 -63 20 -110 64 -267 164 -483 325 -698 87 -116
  274 -309 308 -317 12 -3 126 -4 253 -3 l231 3 -569 575 c-452 457 -568 569
  -568 550z"
      />
      <path
        d="M2725 628 c-357 -359 -554 -564 -544 -566 26 -5 223 45 326 84 275
  102 497 247 701 457 l92 96 0 246 c0 135 -3 245 -7 245 -5 0 -260 -253 -568
  -562z"
      />
      <path
        d="M805 380 c11 -18 190 -123 284 -167 263 -124 490 -173 795 -173 l171
  0 175 175 175 175 -803 0 c-511 0 -801 -3 -797 -10z"
      />
    </g>
  </svg>
);

export default ApertureMining;
